import { createSlice } from '@reduxjs/toolkit';

let expanded = window.innerWidth > 600;
expanded = JSON.parse(localStorage.getItem('expanded'));

const initialState = {
    anchorEl: null,
    isMenuExpanded: expanded
};

const navigationSlice = createSlice({
    name: 'navigation',
    initialState,
    reducers: {
        toogleMenu: (state, action) => {
            localStorage.setItem('expanded', action.payload);
            state.anchorEl = null;
            state.isMenuExpanded = action.payload;
        }
    }
});

export const { toogleMenu } = navigationSlice.actions;

export default navigationSlice.reducer;
